import React from "react";
import { Lock, CheckCircle2 } from "lucide-react";
import { money } from "@/lib/api";

export const BidReceipt = ({ receiptId, amount, createdAt }) => {
    return (
        <div data-testid="bid-receipt" className="rounded-xl border border-success/30 bg-success/5 p-4">
            <div className="mb-3 flex items-center gap-2 text-success">
                <CheckCircle2 className="h-5 w-5" aria-hidden />
                <span className="font-display font-semibold">Sealed bid recorded</span>
            </div>
            <div className="space-y-2 text-sm">
                <div className="flex items-center justify-between">
                    <span className="text-muted-foreground">Your bid (private)</span>
                    <span className="inline-flex items-center gap-1 font-display font-semibold tabular-nums">
                        <Lock className="h-3.5 w-3.5" aria-hidden /> {money(amount)}
                    </span>
                </div>
                <div className="flex items-center justify-between border-t border-dashed border-border pt-2">
                    <span className="text-muted-foreground">Receipt ID</span>
                    <span data-testid="bid-receipt-id" className="font-mono text-xs">{receiptId}</span>
                </div>
                <div className="flex items-center justify-between">
                    <span className="text-muted-foreground">Submitted</span>
                    <span data-testid="bid-receipt-timestamp" className="font-mono text-xs">
                        {new Date(createdAt).toLocaleString()}
                    </span>
                </div>
            </div>
            <p className="mt-3 text-xs text-muted-foreground">
                This is your one and only bid for this item. You cannot edit it or view competing bids.
            </p>
        </div>
    );
};
